export { ComponentDependency, SerializedComponentDependency, TYPE as COMPONENT_DEP_TYPE } from './component-dependency';
export { ComponentDependencyFactory } from './component-dependency-factory';
